import { Tooltip } from '@kira/checkpoint-shared-frontend';
import React from 'react';
import { twMerge } from 'tailwind-merge';

interface SidebarNavigationItemProps {
  description: string;
  Icon?: JSX.Element;
  isCollapsed?: boolean;
  onClick?: () => void;
  isActive?: boolean;
}

const SidebarNavigationButton = ({
  description,
  Icon,
  isCollapsed,
  onClick,
  isActive,
}: SidebarNavigationItemProps) => {
  const isActiveClasses = twMerge(
    'border-kira-blue-800',
    'bg-kira-blue-800',
    'bg-opacity-10'
  );

  const wrapperClasses = twMerge(
    'border-l-4',
    'flex-grow',
    'flex',
    'hover:bg-kira-blue-800',
    'hover:bg-opacity-10',
    'items-center',
    'max-w-[17.5rem]',
    'rounded-r-lg',
    'mr-3',
    'p-2',
    'pl-4',
    'text-kira-blue-800',
    'w-full',
    isCollapsed && 'rounded-full',
    isCollapsed && 'justify-center',
    isActive && isActiveClasses
  );

  return (
    <div className="flex cursor-pointer items-center text-kira-slate-700">
      <Tooltip
        textContent={description}
        isEnabled={isCollapsed}
        tooltipClassNames="left-16 -mt-12"
      >
        <button type="button" className={wrapperClasses} onClick={onClick}>
          {!isCollapsed ? (
            <>
              <div className="h-4 w-4 text-kira-blue-800">{Icon}</div>
              <div className="prose-body-md-med pl-1">{description}</div>
            </>
          ) : null}
        </button>
      </Tooltip>
    </div>
  );
};

export default SidebarNavigationButton;
